import React from "react"
import mount from "core/mount"
import { Note } from "@kit/design/note"
import { TrialRing, useTrialProgress } from "@kit/design/trial-indicator"
import { Button } from "@kit/design/button"
import { useMediaBreakpoint } from "@kit/design/use-media-breakpoint"
import { analytics } from "utils/analytics"

export function TrialUpgradeBanner({ daysRemaining, daysTotal }) {
  const isDesktop = useMediaBreakpoint("md")
  const { safeDaysRemaining, progress, dayLabel } = useTrialProgress(
    daysRemaining ?? 0,
    daysTotal ?? 0
  )

  if (!isDesktop) return null

  function handleUpgradeClick() {
    analytics.track(
      "Element",
      "Clicked",
      {
        element_type: "button",
        text: "Upgrade now",
        location: "trial_upgrade_banner"
      },
      { transport: "beacon" }
    )
    window.location.href = "/upgrade"
  }

  return (
    <Note variant="upsell" layout="inline">
      <Note.ContentLeading>
        <TrialRing progress={progress} />
      </Note.ContentLeading>
      <Note.Content>
        <Note.Heading>
          {safeDaysRemaining} {dayLabel} left on your free trial
        </Note.Heading>
        <p>
          Upgrade to continue to use all the features you have access to without
          interruption.
        </p>
      </Note.Content>
      <Note.Actions>
        <Button size="small" onClick={handleUpgradeClick}>
          Upgrade now
        </Button>
      </Note.Actions>
    </Note>
  )
}

mount({ "Layout.TrialUpgradeBanner": TrialUpgradeBanner })
